import { render, staticRenderFns } from "./update.vue?vue&type=template&id=9297f6e8&"
import script from "./update.vue?vue&type=script&lang=js&"
export * from "./update.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/vercel/workpath0/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9297f6e8')) {
      api.createRecord('9297f6e8', component.options)
    } else {
      api.reload('9297f6e8', component.options)
    }
    module.hot.accept("./update.vue?vue&type=template&id=9297f6e8&", function () {
      api.rerender('9297f6e8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "srcPC/components/update.vue"
export default component.exports